/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreHttp from "@azure/core-http";

export const CommunicationIdentity: coreHttp.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationIdentity",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      }
    }
  }
};

export const CommunicationIdentityUpdateRequest: coreHttp.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationIdentityUpdateRequest",
    modelProperties: {
      tokensValidFrom: {
        serializedName: "tokensValidFrom",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};

export const CommunicationTokenRequest: coreHttp.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationTokenRequest",
    modelProperties: {
      scopes: {
        serializedName: "scopes",
        required: true,
        type: {
          name: "Sequence",
          element: { type: { name: "String" } }
        }
      }
    }
  }
};

export const CommunicationIdentityToken: coreHttp.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CommunicationIdentityToken",
    modelProperties: {
      id: {
        serializedName: "id",
        required: true,
        type: {
          name: "String"
        }
      },
      token: {
        serializedName: "token",
        required: true,
        type: {
          name: "String"
        }
      },
      expiresOn: {
        serializedName: "expiresOn",
        required: true,
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
